<template>
  <div id="settings">
    <header class="inner-head border-transparent h-16">
      <div class="flex justify-between">
        <h2 class="sub-head-title">Course Fields</h2>
      </div>

    </header>


    <div class="w-full h-12 ml-8">
        <p>
          Setup and alter the default Unit/Course section titles. This will alter the display only for all areas within the platform where these titles are shown.

        </p>
      </div>

    <div class="assessmentconfig w-11/12 ml-4 flex">

      <div class="bg-white  w-full  pb-3 mb-10 ">
        <div class="px-4">
        <form
          v-on:submit.prevent="saveSettings()"
          id="form-fields"
          ref="formFields"
        >
          <section>

            <table class="w-full">
              <thead class="bg-gray-100">
                <tr>
                  <th width="w-2/12" class="p-2" align="left">Order</th>
                  <th width="w-3/12" class="text-left pl-4">Field</th>
                  <th width="w-4/12">Replaced Display Title</th>
                  <th class="center w-2/12">Should Display</th>
                  <th class="w-1/12"></th>
                </tr>
              </thead>

              <draggable
                v-model="fieldsList"
                :element="'tbody'"
                :move="onMove"
                @start="drag = true"
                @end="drag = true"
              >
                <tr
                  v-for="(item, index) in fieldsList"
                  :key="item.order"
                  class="course list-complete-item even:bg-gray-200"
                >
                  <td width="w-2/12" class="center pl-4">{{ item.order }}</td>
                  <td width="w-3/12">{{ item.name }}</td>
                  <td width="w-4/12">
                    <input
                      :placeholder="setPlaceholder(item)"
                      v-model="item.value"
                      type="text"
                    />
                  </td>
                  <td align="center" class="w-2/12">
                    <div class="checkbox" v-if="item.protect != true">
                      <input
                        :id="'chkUsed_' + index"
                        :name="'chkUsed_' + index"
                        v-model="item.used"
                        type="checkbox"
                        checked=""
                        v-bind:class="{ active: item.used == true }"
                      />
                      <label :for="'chkUsed_' + index"></label>
                    </div>
                    <i class="icon fas fa-square" v-else />
                  </td>
                  <td class="dragme w-1/12">
                    <i class="icon fas fa-bars"></i>
                  </td>
                </tr>
              </draggable>
            </table>
          </section>
        </form>

        <div class="w-full flex justify-end content-baseline space-x-10 text-right border-t">
          <div class="w-10/12 flex justify-end">

            <p v-if="hasCompleted" class="text-green-500 mt-4">
              Settings configuration saved.
            </p>
               
            <p v-if="errored" class="text-red-500 mt-4">
              We are not able to retrieve this information at the moment, please try
              back later.
            </p>

            <div
              style="text-align: center"
              class=""
              v-if="loading"
            >
              <i class="spinner fa fa-spinner fa-spin text-sm"></i>
              <p>Saving</p>
            </div>
          </div>
         <button
              @click="submitForm()"
              type="button"
              class="publish-button hover:opacity-75 mt-4"
            >
              Publish Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import { settingsMixin } from "@/mixins/settingsMixin.js";

export default {
  name: "assessmentconfig",
  mixins: [settingsMixin],
  computed: {
    ...mapGetters({ currentUser: "currentUser", access: "currentAccess" }),
   
  },
  watch: {
  },
  data() {
    return {
    };
  },
  created() {

  },
  mounted() {
  },
  methods: {
    changeViewParamType() {},
    submitForm() {
      if (this.$refs.formFields.requestSubmit === undefined) {
        this.saveSettings();
      } else {
        this.$refs.formFields.requestSubmit();
      }
    },
   
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return !relatedElement || !relatedElement.fixed;
    },
    setPlaceholder(r) {
      return "Enter " + r.name.toLowerCase() + " title";
    },

  },
  components: {
    draggable,
  },
};
</script>


<style scoped>

.header-subnav {
  @apply text-gray-600  mr-1 font-medium;
}


.header-subnav.selected {
  @apply text-gray-800 my-2 font-semibold  bg-white border-none rounded-lg;
}

h5 {
  text-transform: uppercase;
}


.lean-right {
  text-align: right;
}

.dragme {
  cursor: move;
  font-size: 130%;
}

.small {
  font-size: 90%;
  color: #f56a6a;
  width: 20px;
  display: inline-block;
}

.list-complete-item {
  transition: all 1s;
}

.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
  height: 0px;
  margin-top: 0px;
  padding: 0px;
  border: solid 0px;
}

.list-complete-item input[type="text"] {
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

.list-complete-item td {
  vertical-align: middle !important;
}

.list-complete-item td input[type="checkbox"] + label {
  padding-left: 0em !important;
}

.list-complete-item td .fa-square {
  font-size: 180% !important;
  padding-left: 0.5em;
}

.selected-row {
  @apply bg-blue-100  !important;
}
</style>

